export default "__VITE_ASSET__5fbd6dd3__"